// eslint-disable-next-line no-undef

export default {
  init() {
    $(document).ready(() => {
      blogAjaxLoader.init();
    });
  },
};

let blogAjaxLoader = {
  processing: false,
  trigger: $('.blog-load-more__button'),
  loader: $('.archive__loader'),
  projects: $('.blog-post-list .grid-wrapper'),
  init: () => {

    let $this = blogAjaxLoader;

    if (blogAjaxLoader.processing) {
      return false;
    }

    $($this.trigger).on("click", (e) => { // eslint-disable-line no-undef
      e.preventDefault();
      $this.loadPosts($this);
    });

  },
  loadPosts: ($this) => {

    let nonce = $this.trigger.data("nonce");
    let data = {
      action: 'tdl_load_more_ajax',
      offset: $this.trigger.attr('data-offset'),
      category: $this.trigger.attr('data-category'),
      nonce: nonce,
      query_vars: ajax_object.query, // eslint-disable-line no-undef
    };

    // Do AJAX request
    if (!$this.processing) {

      // Let the user know where working on it // TODO
      $this.trigger.parent().addClass("loading");
      $this.loader.addClass("loading");

      $.post(ajax_object.ajaxurl, data, function(response) { // eslint-disable-line no-undef

        $this.processing = true;

        if (response) {
          let ajaxResponse = JSON.parse(response);
          $this.trigger.attr('data-offset', ajaxResponse.offset);
          $.each(ajaxResponse.rendered, function(key, value) {
            let val = $(value);
            $this.projects.append(val);
          });
        } else {
          $('.blog-load-more').addClass("hidden");
          $('.blog__no-results').removeClass("hidden");
        }

        $this.trigger.parent().removeClass("loading");
        $this.loader.removeClass("loading");

        $this.processing = false; //resets the ajax flag once the callback concludes

        return false;

      });

    } else {
      // trigger.removeClass("loading");
      // $('.grid-wrapper__no-more-posts').addClass("visible");
    }
  },

}



// WEBPACK FOOTER //
// ./scripts/routes/blog.js